import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import * as Sentry from "@sentry/angular";

@Injectable()
export class Sentry409Interceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        if (httpErrorResponse.status === 409) {
          Sentry.addBreadcrumb({
            type: "http",
            level: "fatal",
            category: "http.conflict",
            timestamp: new Date().getTime() / 1000,
            data: {
              url: httpErrorResponse.url,
              method: "POST",
              status_code: 409,
              payload: JSON.stringify(httpErrorResponse.error)
            }
          });
        }

        return throwError(() => httpErrorResponse);
      })
    );
  }
}
